import React from 'react'
import AdminPortalContainer from '../../../containers/admin_portal/layout'

const AdminPortalPage = () => {
  return <AdminPortalContainer />
}

export default AdminPortalPage
